import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 1;

  form {
    width: 100%;
    position: relative;
  }

  img.campanha {
    width: 100%;
  }

  img.close {
    position: absolute;
    width: 28px;
    right: -15px;
    top: -15px;
    cursor: pointer;
  }
`;

export const overlayStyle = {
  zIndex: 5,
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  overflow: "hidden",
  background: "rgba(0, 0, 0, 0.8)",
};

export const contentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  top: 0,
  left: 0,
  minHeight: 150,
  width: "80%",
  maxWidth: 500,
  border: "none",
  borderRadius: "4px",
  padding: 40,
  backgroundColor: "#ffffff",
  textAlign: "center",
  outline: "none",
};

export const Wrap = styled.div`
  display: flex;
  width: 100%;
  margin-top: 24px;
`;

export const Button = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-family: "Quicksand", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-weight: bold;
  background-color: #56a86d;
  color: #ffffff;
  border: none;
  border-radius: 6px;
  width: 100%;
  max-width: 220px;
  padding: 16px 0;
  margin: 0 auto;
  margin-top: 24px;

  .icon-spin {
    animation: iconSpin 2s infinite linear;
  }

  @keyframes iconSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(359deg);
    }
  }
`;
